export default __webpack_public_path__ + "static/media/8821.89a44e2a.svg";